/**
 * Lo que una pantalla necesita saber de un error de la API, sin conocer la
 * forma interna de axios.
 *
 * Contrato de los módulos en capas del backend: `{ mensaje, campo?,
 * rechazadas? }`. Un 5xx nunca muestra su mensaje (es genérico o técnico).
 *
 *   status        código HTTP; null si no hubo respuesta
 *   mensaje       texto para el usuario, o null
 *   campo         dato del pedido que está mal (para marcarlo en el formulario)
 *   rechazadas    detalle por ítem cuando el backend lo manda
 *   sinConexion   no llegó respuesta (red caída, servidor apagado)
 */
export function errorDeApi(error) {
  const respuesta = error && error.response;
  if (!respuesta) {
    return { status: null, mensaje: null, campo: null, rechazadas: [], sinConexion: true };
  }
  const datos = respuesta.data || {};
  const status = respuesta.status;
  return {
    status,
    mensaje: status >= 500 ? null : datos.mensaje || null,
    campo: datos.campo || null,
    rechazadas: Array.isArray(datos.rechazadas) ? datos.rechazadas : [],
    sinConexion: false,
  };
}

/** Texto para mostrar siempre algo, aunque la API no haya dado mensaje. */
export function mensajeDeError(error, porDefecto = 'No se pudo completar la operación. Intente de nuevo.') {
  const { mensaje, sinConexion, status } = errorDeApi(error);
  if (sinConexion) return 'No hay conexión con el servidor. Revise su red e intente de nuevo.';
  if (status === 401) return 'Su sesión venció o no es válida. Vuelva a iniciar sesión.';
  return mensaje || porDefecto;
}
